import authReducer from "./authSlice";
import userReducer from "./userSlice";
import projectsReducer from "./projectSlice";
import visiteReducer from "./visiteSlice";
import programmationReducer from "./programmationSlice";
import dashboardReducer from "./dashboardSlice";

export default {
  auth: authReducer,
  user: userReducer,
  dashboard: dashboardReducer,
  projects: projectsReducer,
  visites:visiteReducer,
  programmations:programmationReducer
};
